import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import {
    IconButton,
    Popover,
    FormControlLabel,
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Radio,
    RadioGroup
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
    saveSearchCondition,
    isViewWasChanged,
    onClickOpenMoveView,
    isDisplayBtnSettingViewIcon
} from '../handler/ViewHandler';
import { DialogConfirmDeleteView } from './DialogConfirmDeleteView';
import { DialogConfirmHideView } from './DialogConfirmHideView';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { editViewsResourceAPI, getListViewByVisibleRange } from '@/service/viewService';
import { cloneDeep } from 'lodash';
import CloseIcon from '@material-ui/icons/Close';
import { PropTypes } from 'prop-types';
import './SettingView.css';

SettingView.propTypes = {
    view: PropTypes.any,
    listView: PropTypes.any,
    onChangeViewSelected: PropTypes.any,
    scrollToViewFunction: PropTypes.any,
    isCustomer: PropTypes.any,
    userRoleInProject: PropTypes.any,
    visibilityKnowledgeAtom: PropTypes.any,
    setIsLoadingView: PropTypes.any,
    setTriggerReloadListView: PropTypes.any,
    setIsOpenDialogViewChanged: PropTypes.any,
    corporationDetail: PropTypes.any,
    API: PropTypes.any,
    userDetail: PropTypes.any,
    isViewFromKnowledgePanel: PropTypes.any,
    viewSelected: PropTypes.any,
};

export default function SettingView(props) {
    const [isConfirmDeleteView, setIsConfirmDeleteView] = useState(false);
    const [isConfirmHideView, setIsConfirmHideView] = useState(false);
    const [openSettingMenu, setOpenSettingMenu] = useState(null);
    const [openPublicRangeMenu, setOpenPublicRangeMenu] = useState(null);
    const [isConfirmPublicRangeChange, setIsConfirmPublicRangeChange] = useState(false);
    const [selectedPublicRangeOption, setSelectedPublicRangeOption] = useState(null);
    const [changedViewInfo, setChangedViewInfo] = useState(null);
    const { userDetail, userRoleInProject, visibilityKnowledgeAtom } = {...props};
    const [isDuplicateView, setIsDuplicateView] = useState(false);
    // Initialize selected public range value based on view.visibleType
    const getInitialSelectedValue = () => {
        return {...props}?.view?.visibleType || '';
    };

    const [selectedPublicRange, setSelectedPublicRange] = useState(getInitialSelectedValue());

    useEffect(() => {
        setSelectedPublicRange(getInitialSelectedValue());
    }, [props?.view?.visibleType]); // eslint-disable-line react-hooks/exhaustive-deps

    // Function to reset all states
    const resetAllStates = () => {
        setOpenSettingMenu(null);
        setOpenPublicRangeMenu(null);
        setIsConfirmPublicRangeChange(false);
        setSelectedPublicRangeOption(null);
        setChangedViewInfo(null);
        setSelectedPublicRange(getInitialSelectedValue());
    };

    const onClickViewSetting = event => {
        setOpenSettingMenu(event.currentTarget);
    };

    const checkViewName = async (nameOfViewUpdate, visibleRange, visibleType) => {
        nameOfViewUpdate = Utils.convertJSONDataToObject(nameOfViewUpdate);
        nameOfViewUpdate = nameOfViewUpdate['jp']?.text;
        nameOfViewUpdate = nameOfViewUpdate.trim()?.toLowerCase();
        let listViewLasted = await getListViewByVisibleRange(
            { ...props }?.API,
            { ...props }?.projectSelectedId,
            visibleRange,
            visibleType
        );

        let listCheck = listViewLasted.filter(v => {
            let viewNameObj = JSON.parse(v.name);
            let viewName = viewNameObj['jp'].text;
            viewName = viewName.trim().toLowerCase();

            return viewName.localeCompare(nameOfViewUpdate.toLowerCase()) === 0;
        });

        return listCheck;
    };

    const handleClose = () => {
        resetAllStates();
    };

    const onClickChangePublicRange = event => {
        // Don't close the parent popover
        setOpenPublicRangeMenu(event.currentTarget);
    };

    const handlePublicRangeClose = () => {
        // Check if any option is selected and different from current
        const currentVisibleType = {...props}?.view?.visibleType;

        if (selectedPublicRange && selectedPublicRange !== currentVisibleType) {
            setSelectedPublicRangeOption(selectedPublicRange);
            // Save view change information
            setChangedViewInfo({
                viewId: {...props}?.view?.id,
                viewName: {...props}?.view?.name,
                oldPublicType: currentVisibleType,
                newPublicType: selectedPublicRange
            });
            setIsConfirmPublicRangeChange(true);
        } else {
            // Reset state when closing popup without changes
            setOpenPublicRangeMenu(null);
            setSelectedPublicRange(getInitialSelectedValue());
            setSelectedPublicRangeOption(null);
            setChangedViewInfo(null);
        }
    };

    const handlePublicRangeChange = (event) => {
        setSelectedPublicRange(event.target.value);
    };

    const handleConfirmPublicRangeChange = async () => {
        try {
            // Complete information about the changed view

            let visibilityRange = '';
            switch (changedViewInfo?.newPublicType) {
                case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
                    visibilityRange = {...props}?.userDetail?.id;
                    break;
                case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
                    visibilityRange = {...props}?.projectSelectedId;
                    break;
                case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
                    visibilityRange = {...props}?.corporationSelectedId;
                    break;
                case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
                    visibilityRange = {...props}?.projectSelectedId;
                    break;
                default:
            }
            props?.setIsLoadingView(true);
            setIsConfirmPublicRangeChange(false);
            setOpenPublicRangeMenu(null);
            setOpenSettingMenu(null);
            let listCheck = await checkViewName(
                changedViewInfo?.viewName,
                visibilityRange,
                changedViewInfo?.newPublicType
            );

            if (listCheck?.length) {
                props?.setIsLoadingView(false);
                setIsDuplicateView(true);
                return;
            }

            let updateViewDto = {
                viewId: changedViewInfo?.viewId,
                userId: { ...props }?.userDetail?.id,
                projectId: { ...props }?.projectSelectedId,
                corporationId: { ...props }?.corporationSelectedId,
                newVisibleType: changedViewInfo?.newPublicType
            };

            let updateViewResult = await editViewsResourceAPI({...props}?.API, {
                method: Constant.UPDATE_VIEW_RESOURCE_METHOD.UPDATE_PUBLIC_RANGE_VIEW,
                updateViewDto: JSON.stringify(updateViewDto)
            });
            if (updateViewResult.id) {
                //update list view
                props?.setTriggerReloadListView(new Date().getTime());
            }
            props?.setIsLoadingView(false);

            // Close all popups after success
            resetAllStates();

            // Can add success notification here
        } catch (error) {
            console.error('Error updating view public range:', error);
            // Close confirm popup but keep menu popup for user to retry
            setIsConfirmPublicRangeChange(false);
            setSelectedPublicRangeOption(null);
            setChangedViewInfo(null);
            props?.setIsLoadingView(false);
            setOpenPublicRangeMenu(null);
            setOpenSettingMenu(null);
            // Can add error notification here
            // props?.showErrorMessage('Failed to update view public range');
        }
    };

    const handleCancelPublicRangeChange = () => {
        resetAllStates();
    };

    const onClickDeleteView = async () => {
        setOpenSettingMenu(null);

        // Check if view was changed
        let isViewChanged = await isViewWasChanged({...props}?.view, props);
        if (isViewChanged) {
            props?.setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmDeleteView(true);
        }
    };

    const onClickHideView = async () => {
        setOpenSettingMenu(null);

        // Check if view was changed
        let isViewChanged = await isViewWasChanged({...props}?.view, props);
        if (isViewChanged) {
            props?.setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmHideView(true);
        }
    };

    const onClickSaveSearchCondition = async () => {
        setOpenSettingMenu(null);

        // Check if view was changed
        let isViewChanged = await isViewWasChanged({...props}?.view, props);
        if (isViewChanged) {
            props?.setIsOpenDialogViewChanged(true);
        } else {
            await saveSearchCondition(props?.view, props);
        }
    };

    const onClickMoveView = async () => {
        setOpenSettingMenu(null);

        // Check if view was changed
        let isViewChanged = await isViewWasChanged({...props}?.view, props);
        if (isViewChanged) {
            props?.setIsOpenDialogViewChanged(true);
        } else {
            onClickOpenMoveView(props?.view, props);
        }
    };

    const isShowViewAction = () => {
        switch (props?.view?.visibleType) {
            case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
                return true;
            case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
                return userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR;
            default:
                return false;
        }
    };

    const isShowMoveView = () => isShowViewAction();
    const isShowHideView = () => isShowViewAction();

    const onClosePopupDuplicateView = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        
        // Close popup
        setIsDuplicateView(false);

        // Focus vào view hiện tại
        let listViewClone = cloneDeep({...props}?.listView);
        let index = listViewClone.findIndex(v => v.id === changedViewInfo?.viewId);

        if (index !== -1) {
            if (props?.onChangeViewSelected) {
                props?.onChangeViewSelected(listViewClone[index], props, props?.corporationDetail);
            }
            
        }

        // Reset all states
        resetAllStates();
    };

    const isShowOptionSaveCondition = () => {
        if ({...props}?.viewSelected?.id !== {...props}?.view?.id) return false;

        switch (props?.view?.visibleType) {
            case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
                return (
                    props?.view?.viewType === Constant.VIEW_TYPE.CUSTOM &&
                    (userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR ||
                        userDetail?.id === props?.view?.creator)
                );
            case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
                return (
                    props?.view?.viewType === Constant.VIEW_TYPE.CUSTOM &&
                    userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR
                );
            default:
                return false;
        }
    };

    const isShowOptionDeleteView = () => {
        switch ({...props}?.view?.visibleType) {
            case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
                return (
                    props?.view?.viewType === Constant.VIEW_TYPE.CUSTOM &&
                    (userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR ||
                        userDetail?.id === props?.view?.creator)
                );
            case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
                return (
                    props?.view?.viewType === Constant.VIEW_TYPE.CUSTOM &&
                    userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR
                );
            default:
                return false;
        }
    };

    const isDisplayBtnPublicRange = view => {
        // Don't show for DEFAULT view types
        if (view.viewType === Constant.VIEW_TYPE.DEFAULT) {
            return false;
        }

        const isCreator = userDetail?.id === view?.creator;
        const isProjectManager = userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR;

        // Condition 1: PRIVATE or PROJECT - show for creator or project manager
        if (
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.PRIVATE ||
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.PROJECT
        ) {
            return isCreator || isProjectManager;
        }

        // Condition 2: IN_ORG or CUSTOMER - show only for creator who is also project manager
        if (
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.IN_ORG ||
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
        ) {
            return isProjectManager;
        }

        return false;
    };

    const getOptionDisabledState = option => {
        const isCreator = userDetail?.id === props?.view?.creator;
        const isProjectManager = userRoleInProject === Constant.PRIVILEGE_PROJECT.PRJ_MGR;
        // visibilityKnowledgeAtom == PRIVATE hoặc PROJECT
        if (
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.PRIVATE ||
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.PROJECT
        ) {
            if (isProjectManager && isCreator) {
                return false;
            }

            if (isProjectManager && !isCreator) {
                return option === Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
            }

            if (isCreator && !isProjectManager) {
                return (
                    option === Constant.VISIBILITY_SETTING_TYPE.IN_ORG ||
                    option === Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
                );
            }

            return true;
        }

        if (
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.IN_ORG ||
            visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
        ) {
            if (isProjectManager && isCreator) {
                return false;
            }

            if (isProjectManager && !isCreator) {
                return option === Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
            }

            return isCreator && !isProjectManager;
        }

        return true;
    };

    const getMsgConfirmPublicRangeChange = option => {
        switch (option) {
            case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
                return 'ビューの公開範囲を「プライベート」に変更してもよろしいですか？';
            case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
                return 'ビューの公開範囲を「プロジェクト」に変更してもよろしいですか？';
            case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
                return (
                    <>
                        ビューの公開範囲を「組織内」に変更してもよろしいですか？
                        <br />
                        （見え方設定に応じて表示されるナレッジが変わります）
                    </>
                );
            case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
                return (
                    <>
                        ビューの公開範囲を「一般公開」に変更してもよろしいですか？
                        <br />
                        （見え方設定「一般公開」では公開範囲が「一般公開」のナレッジのみ表示されます）
                    </>
                );
            default:
                return '';
        }
    };

    return (
        <>
            {isDisplayBtnSettingViewIcon(
                props?.isCustomer,
                props?.userRoleInProject,
                { visibility: props?.view?.visibleType },
                props?.isViewFromKnowledgePanel
            ) && (
                <IconButton
                    className="btn-showMore"
                    onClick={onClickViewSetting}
                    style={{ verticalAlign: 'middle', padding: '4px 10px' }}
                >
                    <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                </IconButton>
            )}
            <Popover
                className="navTabs-dropMenu"
                id={`${props?.view.id}-simple-menu`}
                anchorEl={openSettingMenu}
                keepMounted
                open={Boolean(openSettingMenu)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                // Add logic to close popup when clicking outside
                disableRestoreFocus
                disableAutoFocus
                disableEnforceFocus
                onDoubleClick={(e) => e.stopPropagation()}
            >
                <ul>
                    {isDisplayBtnPublicRange(props?.view) && (
                        <li onClick={onClickChangePublicRange}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-hide.svg" alt="" />
                            </span>
                            <span className="navTabs-text">公開範囲</span>
                        </li>
                    )}
                    {isShowHideView() && (
                        <li onClick={onClickHideView}>
                            <span className="navTabs-item">
                                <VisibilityOffIcon style={{ fontSize: '16px', color: '#666' }} />
                            </span>
                            <span className="navTabs-text">非表示</span>
                        </li>
                    )}
                    {isShowOptionDeleteView() && (
                        <li onClick={onClickDeleteView}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                            </span>
                            <span className="navTabs-text">削除</span>
                        </li>
                    )}
                    {isShowMoveView() && (
                        <li onClick={onClickMoveView}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-move.svg" alt="" />
                            </span>
                            <span className="navTabs-text">移動</span>
                        </li>
                    )}
                    {isShowOptionSaveCondition() && (
                        <li onClick={onClickSaveSearchCondition}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-search.svg" alt="" />
                            </span>
                            <span className="navTabs-text">検索条件保存</span>
                        </li>
                    )}
                </ul>
            </Popover>

            {/* Public Range Popover */}
            <Popover
                className="navTabs-dropMenu public-range-view-knowledge-listOption"
                id={`${props?.view.id}-public-range-menu`}
                anchorEl={openPublicRangeMenu}
                keepMounted
                open={Boolean(openPublicRangeMenu)}
                onClose={handlePublicRangeClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                // Add logic to close popup when clicking outside
                disableRestoreFocus
                disableAutoFocus
                disableEnforceFocus
                onDoubleClick={(e) => e.stopPropagation()}
            >
                <div className="public-range-view-knowledge-listOption">
                    <RadioGroup
                        value={selectedPublicRange}
                        onChange={handlePublicRangeChange}
                    >
                        <FormControlLabel
                            value={Constant.VISIBILITY_SETTING_TYPE.PRIVATE}
                            control={
                                <Radio
                                    color="primary"
                                    disabled={getOptionDisabledState(
                                        Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                                    )}
                                />
                            }
                            className={`label-radio-change-public-range ${selectedPublicRange === Constant.VISIBILITY_SETTING_TYPE.PRIVATE ? 'selected' : ''}`}
                            label="プライベート"

                        />
                        <FormControlLabel
                            value={Constant.VISIBILITY_SETTING_TYPE.PROJECT}
                            control={
                                <Radio
                                    color="primary"
                                    disabled={getOptionDisabledState(
                                        Constant.VISIBILITY_SETTING_TYPE.PROJECT
                                    )}
                                />
                            }
                            className={`label-radio-change-public-range ${selectedPublicRange === Constant.VISIBILITY_SETTING_TYPE.PROJECT ? 'selected' : ''}`}
                            label="プロジェクト"
                        />
                        <FormControlLabel
                            value={Constant.VISIBILITY_SETTING_TYPE.IN_ORG}
                            control={
                                <Radio
                                    color="primary"
                                    disabled={getOptionDisabledState(
                                        Constant.VISIBILITY_SETTING_TYPE.IN_ORG
                                    )}
                                />
                            }
                            className={`label-radio-change-public-range ${selectedPublicRange === Constant.VISIBILITY_SETTING_TYPE.IN_ORG ? 'selected' : ''}`}
                            label="組織内"
                        />
                        <FormControlLabel
                            value={Constant.VISIBILITY_SETTING_TYPE.CUSTOMER}
                            control={
                                <Radio
                                    color="primary"
                                    disabled={getOptionDisabledState(
                                        Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
                                    )}
                                />
                            }
                            className={`label-radio-change-public-range ${selectedPublicRange === Constant.VISIBILITY_SETTING_TYPE.CUSTOMER ? 'selected' : ''}`}
                            label="一般公開"
                        />
                    </RadioGroup>
                </div>
            </Popover>

            <DialogConfirmDeleteView
                viewDelete={props?.view}
                isConfirmDeleteView={isConfirmDeleteView}
                setIsConfirmDeleteView={setIsConfirmDeleteView}
                {...props}
            />

            <DialogConfirmHideView
                viewHide={props?.view}
                isConfirmHideView={isConfirmHideView}
                setIsConfirmHideView={setIsConfirmHideView}
                {...props}
            />

            <ConfirmDialog
                isOpen={isConfirmPublicRangeChange}
                msgConfirm={getMsgConfirmPublicRangeChange(selectedPublicRangeOption)}
                okCallBack={handleConfirmPublicRangeChange}
                closeCallBack={handleCancelPublicRangeChange}
            />
            <Dialog
                open={isDuplicateView}
                onClose={(event, reason) => onClosePopupDuplicateView(event, reason)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
            >
                <DialogContent>
                    <div className="confirm-dialog-content">
                        {'入力したビュー名は既に登録されています。他の名称を入力してください。'}
                        <IconButton
                            className="close"
                            onClick={(event, reason) => onClosePopupDuplicateView(event, reason)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogContent>
                <DialogActions className="confirm-dialog-action">
                    <Button
                        className="confirm-dialog-button"
                        variant="contained"
                        color="primary"
                        onClick={(event, reason) => onClosePopupDuplicateView(event, reason)}
                        style={{ backgroundColor: '#3f51b5' }}
                    >
                        はい
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};